import styles from './styles.module.css'
export default function OutcomeTool({dict}) {
    const {outcome_ces_tool_1, outcome_ces_tool_2, outcome_ces_tool_3,  outcome_ces_tool_4} = dict.discover;
    return (
        <section className={styles.container}>
            <p dangerouslySetInnerHTML={{ __html: outcome_ces_tool_1 }} />
            <p dangerouslySetInnerHTML={{ __html: outcome_ces_tool_2 }} />
            <p dangerouslySetInnerHTML={{ __html: outcome_ces_tool_3 }} />
            <p dangerouslySetInnerHTML={{__html: outcome_ces_tool_4}}/>
        </section>
    );
}
